const COMBATE_A_FRAUDE_EXECUTION_ID = "5f4ffa83f5b57a00076eacd1";

const SUPPORTED_CONTENT_TYPES = {
  cpf: "CPF",
  birthDate: "Data de Nascimento",
  rg: "RG",
  issueDate: "Data emissao",
  issuingAuthority: "Orgão emissao",
  issueState: "Estado",
  name: "Nome"
};

const OCR_DOCUMENTS = ["CNH", "RG", "RNE", "SELFIE"];

const BACKGROUND_CHECK_DOCUMENTS = [
  "PF_PROCESSES",
  "PF_MEDIA_PROFLE_EXPOSURE",
  "PF_SOCIAL_ASSISTANCE",
  "PF_OCCUPATION_DATA",
  "PF_PROTESTO",
  "PF_ANTECEDENTES",
  "PF_CRIMINAL_BACKGROUND",
  "PF_BASIC_DATA"
];

const GENERIC_DOCUMENTS = ["PROOF_OF_ADDRESS"];

const OCR_DOCUMENTS_CONTENT = ["CNH", "RG", "RNE"];

const DOCUMENT_STATUS_PROCESSING = ["processing"];

const DOCUMENT_STATUS_HANDLED = ["processing", "pending_approval"];

const DOCUMENT_STATUS_VALID_TO_PROCCESS = ["created", "pending_approval"];

const OCR_DOCUMENTS_STATUSES = {
  CNH: "Carteira de habilitação",
  RG: "Carteira de identidade",
  RNE: "Registro nacional de estrangeiros",
  SELFIE: "Selfie",
  PROOF_OF_ADDRESS: "Comprovante de residência"
};

const BACKGROUND_CHECK_DOCUMENTS_STATUSES = {
  PF_PROCESSES: "Processos",
  PF_MEDIA_PROFILE_EXPOSURE: "Exposição na mídia",
  PF_SOCIAL_ASSISTANCE: "Assistência social",
  PF_OCCUPATION_DATA: "Informações profissionais e acadêmicas",
  PF_PROTESTO: "Informações judiciais",
  PF_ANTECEDENTES: "Antecedentes criminais",
  PF_CRIMINAL_BACKGROUND: "Antecedentes criminais",
  PF_BASIC_DATA: "Dados pessoais "
};

const ANSWER = {
  true: {
    order: 1,
    name: "APROVADO",
    icon: "mdi-check-decagram",
    event: "Documento aprovado",
    description: "O documento está aprovado",
    color: "green"
  },
  false: {
    order: 2,
    name: "REPROVADO",
    icon: "mdi-close-circle",
    event: "Documento reprovado",
    description: "Documento foi reprovado",
    color: "red"
  }
};

const STATUSES = {
  created: {
    order: 1,
    name: "Criado",
    icon: "mdi-check-decagram",
    event: "Documento criado",
    description: "O documento foi criado",
    color: "green"
  },
  waiting_processing: {
    order: 2,
    name: "Esperando processar",
    icon: "mdi-tray-full",
    event: "Esperando processar",
    description: "O documento está esperando processamento",
    color: "orange"
  },
  processing: {
    order: 3,
    name: "Processando",
    icon: "mdi-progress-upload",
    event: "Documento processando",
    description: "O Documento está em processamento",
    color: "orange"
  },
  pending_approval: {
    order: 4,
    name: "Necessita aprovação manual",
    icon: "mdi-badge-account-alert",
    event: "Documento em aprovação manual",
    description: "Documento necessita de aprovação manual",
    color: "purple"
  },
  approved: {
    order: 5,
    name: "Aprovado",
    icon: "mdi-check-circle",
    event: "Documento aprovado",
    description: "Documento foi aprovado",
    color: "green"
  },
  reproved: {
    order: 6,
    name: "Reprovado",
    icon: "mdi-close-circle",
    event: "Documento reprovado",
    description: "Documento foi reprovado",
    color: "red"
  }
};

const getOnboardingAndAutomationReportId = () =>
  process.env.DATA_ASSURANCE_ONBOARDING_AND_AUTOMATION_REPORT_ID;

const getBackgroundCheckReportId = () =>
  process.env.DATA_ASSURANCE_BACKGROUND_CHECK_REPORT_ID;

function reportIdByDocumentType(documentType) {
  if (isOcrDocument(documentType)) {
    return getOnboardingAndAutomationReportId();
  } else if (isBackgroundCheckDocument(documentType)) {
    return getBackgroundCheckReportId();
  } else {
    return "";
  }
}

function getSelfiePath(element) {
  return element["selfie"];
}

function isApproved(answer) {
  return ANSWER[answer];
}

const isOcrDocument = value => {
  return OCR_DOCUMENTS.includes(value);
};

const isBackgroundCheckDocument = value => {
  return BACKGROUND_CHECK_DOCUMENTS.includes(value);
};

const isOcrDocumentContent = value => {
  return OCR_DOCUMENTS_CONTENT.includes(value);
};

const getStatuses = (status, field) => {
  return STATUSES[status][field];
};

const getStatus = status => {
  return STATUSES[status];
};

const getContent = type => {
  return SUPPORTED_CONTENT_TYPES[type];
};

const isDocumentHandled = document_status => {
  return DOCUMENT_STATUS_HANDLED.includes(document_status);
};

const isDocumentReadyToProcess = document_status => {
  return DOCUMENT_STATUS_VALID_TO_PROCCESS.includes(document_status);
};

const isDocumentProcessing = document_status => {
  return DOCUMENT_STATUS_PROCESSING.includes(document_status);
};

const getDocumentTypeStatuses = documentType => {
  return OCR_DOCUMENTS_STATUSES[documentType];
};

const getBackgroundDocumentTypeStatuses = documentType => {
  return BACKGROUND_CHECK_DOCUMENTS_STATUSES[documentType];
};

const buildCombateAFraudeLink = reportId => {
  return `https://app.combateafraude.com/executions/${reportId}?r=${COMBATE_A_FRAUDE_EXECUTION_ID}`;
};

export default {
  filters: {
    getStatuses,
    getDocumentTypeStatuses,
    getBackgroundDocumentTypeStatuses,
    isApproved
  },
  methods: {
    getSelfiePath,
    getStatus,
    getContent,
    isOcrDocument,
    isApproved,
    isOcrDocumentContent,
    isDocumentHandled,
    getDocumentTypeStatuses,
    isDocumentReadyToProcess,
    reportIdByDocumentType,
    isBackgroundCheckDocument,
    buildCombateAFraudeLink,
    isDocumentProcessing
  }
};



// WEBPACK FOOTER //
// ./src/mixins/documentMixin.js